import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Template from './template';
import * as S from './style';
import { Label, BtnService } from 'components';
import {
  PAGE_SERVICE_SELECT_TITLE_1,
  PAGE_SERVICE_SELECT_TITLE_2,
  PAGE_SERVICE_SELECT_SUB_TITLE,
  PAGE_SERVICE_SELECT_CAPTION,
} from 'commons/ZimssaString';
import { SERVICE_INFO } from 'commons/ZimssaConstant';
import useApiRequest from 'hooks/useApiRequest';
import * as PAGE_URL from 'router/PageUrl';

import { apiGetServiceProgress } from 'api/ZimssaAPI';

interface IServiceStatusInfo {
  idx: number;
  serviceType: string;
  serviceName: string;
  serviceImage: string;
  serviceDocStatus: string;
  serviceActiveStatus: string;
  isTempData: boolean;
}

const defaultInfo: IServiceStatusInfo = {
  idx: 0,
  serviceType: '',
  serviceName: '',
  serviceImage: '',
  serviceDocStatus: '',
  serviceActiveStatus: '',
  isTempData: false,
};

export function createUrl(type: string, status?: string, idx?: number): string {
  const serviceIdx = `/${idx}`;
  /**
   * TODO: move_cleaning 부분만 따로 _있는 상태로 유지하는 부분 수정
   */
  const serviceType =
    type !== 'move_cleaning' ? `/${type.replace('_', '')}` : `/${type}`;

  switch (status) {
    case 'doc_wait': // 서류 제출
      return `${PAGE_URL.SERVICE_DOCWAIT.url}${serviceType}${serviceIdx}`;
    case 'doc_checked': // 서류 완료
      return `${PAGE_URL.SERVICE_DOCCHECKED.url}${serviceType}${serviceIdx}`;
    case 'doc_reject': // 서류 오류
      return `${PAGE_URL.SERVICE_DOCREJECT.url}${serviceType}${serviceIdx}`;
    case 'interview_notice': // 인터뷰 고지
      return `${PAGE_URL.SERVICE_INTERVIEWNOTICE.url}${serviceType}${serviceIdx}`;
    case 'interview_answer': // 인터뷰 응답
    case 'interview_progress': // 인터뷰 진행
      return `${PAGE_URL.SERVICE_INTERVIEWANSWER.url}${serviceType}${serviceIdx}`;
    case 'interview_noanswer': // 인터뷰 미응답
      return `${PAGE_URL.SERVICE_INTERVIEWNOANSWER.url}${serviceType}${serviceIdx}`;
    case 'interview_nonapprove': // 인터뷰 비승인
      return `${PAGE_URL.SERVICE_INTERVIEWNOAPPROVE.url}${serviceType}${serviceIdx}`;
    case 'interview_approve': // 인터뷰 승인
    case 'approve_check': // 활동 최종승인 검토 요청 (기사님이 최종승인 하는것)
      return `${PAGE_URL.SERVICE_INTERVIEWAPPROVE.url}${serviceType}${serviceIdx}`;
    case 'approve_reject': // 활동승인거절
      return serviceType === '/move_cleaning'
        ? `${PAGE_URL.SERVICE_INTERVIEWNOAPPROVE.url}${serviceType}${serviceIdx}`
        : `${PAGE_URL.SERVICE_APPROVEREJECT.url}${serviceType}${serviceIdx}`;
    case 'inactive': // 비활성 4주간 15건 견적 미만
    case 'suspended': // 일시정지
      return '';
    case 'approve': // 활동
      return `/service${serviceType}`;
    default:
      if (type === 'small_move') {
        return PAGE_URL.SMALLMOVE_REGISTER.url;
      } else if (type === 'family_move') {
        return PAGE_URL.FAMILYMOVE_REGISTER.url;
      } else {
        return PAGE_URL.MOVECLEANING_REGISTER.url;
      }
  }
}

function ServiceSelectView(): React.ReactElement {
  const [serviceProps, setServiceProps] = useState<
    Array<{
      btnName: string;
      serviceTypeName?: string;
      description?: string;
      serviceName?: string;
      serviceImage?: string;
      serviceDocStatus?: string;
      serviceActiveStatus?: string;
      onClick: () => void;
    }>
  >();

  const [fetchGetServiceStatusResult, fetchGetServiceStatus] =
    useApiRequest<any>(apiGetServiceProgress);
  const history = useHistory();

  useEffect(() => {
    fetchGetServiceStatus({
      type: 'REQUEST',
    });
  }, [fetchGetServiceStatus]);

  useEffect(() => {
    const { data, result } = fetchGetServiceStatusResult;
    let serviceList = new Array<IServiceStatusInfo>();

    if (result === 'success' && data) {
      serviceList = data;
    }

    const servicePropsArr = Object.keys(SERVICE_INFO).map((type) => {
      const service =
        serviceList.find((item) => item.serviceType === type) ||
        Object.assign(defaultInfo, { serviceType: type });
      const serviceStatus = service
        ? service.isTempData && service.serviceDocStatus === 'nodoc'
          ? 'isTemp'
          : service.serviceDocStatus
        : undefined;
      const serviceIdx = service.idx > 0 ? service.idx : undefined;

      return {
        btnName: `btn${type}`,
        serviceTypeName: `${SERVICE_INFO[type].name}`,
        description: SERVICE_INFO[type].description,
        serviceStatus: serviceStatus,
        onClick: () => {
          history.push(createUrl(type, serviceStatus, serviceIdx));
        },
      };
    });

    setServiceProps(servicePropsArr);
  }, [fetchGetServiceStatusResult, history]);

  return (
    <Template>
      <S.TitleContainer>
        <S.TitleWrapper>
          <Label
            contents={PAGE_SERVICE_SELECT_TITLE_1}
            color={'gray_opacity_800'}
            fontStyle={'h3_bold'}
          />
        </S.TitleWrapper>
        <S.TitleWrapper>
          <Label
            contents={PAGE_SERVICE_SELECT_TITLE_2}
            color={'gray_opacity_800'}
            fontStyle={'h3_bold'}
          />
        </S.TitleWrapper>
      </S.TitleContainer>
      <S.SubTitleWrapper>
        <Label
          contents={PAGE_SERVICE_SELECT_SUB_TITLE}
          color={'gray_opacity_600'}
          fontStyle={'title'}
        />
      </S.SubTitleWrapper>
      <S.BtnServiceContainer>
        {serviceProps
          ? serviceProps.map((item, index) => (
              <S.BtnServiceWrapper key={index}>
                <BtnService {...item} />
              </S.BtnServiceWrapper>
            ))
          : null}
      </S.BtnServiceContainer>
      <S.CaptionWrapper>
        <Label
          contents={PAGE_SERVICE_SELECT_CAPTION}
          color={'gray_opacity_400'}
          fontStyle={'caption'}
        />
      </S.CaptionWrapper>
    </Template>
  );
}

export default ServiceSelectView;
